"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpressionValidator = void 0;
const EventNames_1 = require("./EventNames");
class ImpressionValidator {
    elements;
    processedElements = [];
    elementResizeObserver;
    constructor(parentContainer, providedClass) {
        if (!parentContainer)
            return;
        const elements = this.convertToHTMLElementList(parentContainer.querySelectorAll('.' + providedClass));
        if (elements.length === 0)
            return;
        this.elements = elements;
        this.processedElements = [];
        this.elementResizeObserver = this.getElementResizeObserver();
        this.processElements();
        window.addEventListener('scroll', () => {
            this.processElements();
        }, { passive: true });
        window.addEventListener('resize', () => {
            this.processElements();
        });
        parentContainer.addEventListener('scroll', () => {
            this.processElements();
        }, { passive: true });
    }
    getElementResizeObserver() {
        return new ResizeObserver((entries) => {
            for (let entry of entries) {
                this.processElement(entry.target);
            }
        });
    }
    processObservableElements() {
        if (!this.elements || !this.elementResizeObserver)
            return;
        for (let element of this.elements) {
            if (this.elementHasNoDimensions(element.getBoundingClientRect())) {
                this.elementResizeObserver.observe(element);
                continue;
            }
            this.processElement(element);
        }
    }
    processElement(element) {
        if (!element)
            return;
        if (this.isVisible(element)) {
            element.dispatchEvent(new CustomEvent(EventNames_1.EventNames.VALIDATED_IMPRESSION));
            this.processedElements.push(element);
        }
        else {
            this.elements?.push(element);
        }
        this.elementResizeObserver?.unobserve(element);
    }
    processElements() {
        if (!this.elements)
            throw new Error("ImpressionValidator: Elements not set!");
        const elementsCopy = [];
        this.elements.forEach(item => {
            if (this.isVisible(item)) {
                item.dispatchEvent(new CustomEvent(EventNames_1.EventNames.VALIDATED_IMPRESSION));
                this.processedElements.push(item);
            }
            else {
                elementsCopy.push(item);
            }
        });
        this.elements = elementsCopy;
    }
    updateElements(parentContainer, providedClass) {
        if (!parentContainer)
            throw new Error("ImpressionValidator: no parent container provided!");
        const elements = this.convertToHTMLElementList(parentContainer.querySelectorAll('.' + providedClass));
        const elementsCopy = [];
        elements.forEach(element => {
            if (!this.processedElements.find(item => item === element)) {
                elementsCopy.push(element);
            }
        });
        this.elements = elementsCopy;
        this.processElements();
    }
    convertToHTMLElementList(nodeList) {
        const elementList = [];
        for (const node of nodeList) {
            elementList.push(node);
        }
        return elementList;
    }
    isVisible(element) {
        if (!element)
            return false;
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
        if (this.elementHasNoDimensions(rect))
            return false;
        return this.isElementInViewVertical(rect, windowHeight) && this.isElementInViewHorizontal(rect, windowWidth);
    }
    elementHasNoDimensions(rect) {
        return rect.width <= 0 || rect.height <= 0;
    }
    isElementInViewVertical(rect, windowHeight) {
        return (rect.top <= (windowHeight - rect.height * 0.33)) && ((rect.top + rect.height * 0.66) >= 0);
    }
    isElementInViewHorizontal(rect, windowWidth) {
        return (rect.left <= (windowWidth - rect.width * 0.33)) && ((rect.left + rect.width * 0.66) >= 0);
    }
}
exports.ImpressionValidator = ImpressionValidator;
